// extracted by mini-css-extract-plugin
export default {"whatsapp":"ContactUs_whatsapp__y-gIe"};